import { render, staticRenderFns } from "./MobileHeaderSearchOverlayModal.vue?vue&type=template&id=afb87846&scoped=true"
import script from "./MobileHeaderSearchOverlayModal.vue?vue&type=script&lang=ts"
export * from "./MobileHeaderSearchOverlayModal.vue?vue&type=script&lang=ts"
import style0 from "./MobileHeaderSearchOverlayModal.vue?vue&type=style&index=0&id=afb87846&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb87846",
  null
  
)

export default component.exports